import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function PricingSection() {
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-115">
      <div className="max-w-2xl mx-auto text-center" data-id="element-116">
        <FadeIn data-id="element-117">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-118">
            El momento es ahora
          </h2>
          <p className="text-xl mb-8 leading-relaxed text-brand-gray/90" data-id="element-119">
            Recupera la conexión con tus hijos hoy mismo por menos de lo que
            cuesta una cena de comida rápida. Blindar tu relación con ellos para
            los próximos años no debería ser un lujo.
          </p>

          <div className="bg-brand-cream p-8 md:p-12 rounded-2xl border-2 border-brand-amber/30 mb-8" data-id="element-120">
            <div className="text-5xl md:text-6xl font-bold text-brand-brown mb-2 font-serif" data-id="element-121">
              6,39 €
            </div>
            <p className="text-brand-gray/60 uppercase tracking-wider text-sm font-bold mb-8" data-id="element-122">
              Pago único
            </p>

            <Button className="w-full md:w-auto md:px-12 py-5 text-xl" data-id="element-123">
              👉 DESCARGAR GUÍA AHORA
            </Button>

            <p className="text-sm mt-6 text-brand-gray/60" data-id="element-124">
              Acceso inmediato tras el pago. Formato PDF compatible con
              cualquier dispositivo.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}